import React, { Children, useEffect, useMemo, useState } from "react";
import { IoMdClose } from "react-icons/io";
import AppSelectInput from "../../base-components/AppSelectInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Input from "../../Input";
import CustomSelect from "../../CustomSelect";
import { useBankList } from "../../../sevices/hooks/meta-data";
import {
  useCreateRole,
  useResolveBankName,
} from "../../../sevices/hooks/admin";
import { toast } from "react-toastify";
interface ModalProps {
  title: string;
  subtitle: string;
  isOpen: boolean;
  onClose: () => void;
}

const AddRole: React.FC<ModalProps> = ({
  title,
  isOpen,
  onClose,
  subtitle,
}) => {
  const [role, setRole] = useState("");
  const [roleDescription, setRoleDescription] = useState("");
  const overLayRef = React.useRef(null);
  const [loading, setLoading] = useState(false);
  const createRole = useCreateRole();
  const handleOverLayClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (e.target === overLayRef.current) {
      onClose();
    }
  };

  const handleRoleCreation = () => {
    setLoading(true);
    createRole
      .mutateAsync({
        name: role,
        code: role.toLowerCase().replace(/ /g, "_"),
        description: roleDescription,
      })
      .then((res) => {
        setLoading(false);
        toast.success("Role Created Successful");
      })
      .catch((err) => {
        setLoading(false);
        toast.warn("Something went wrong");
      });
  };

  return (
    <>
      {isOpen ? (
        <div className="modal  fixed w-full h-full top-0 left-0 justify-center items-center transition-opacity duration-300 z-50">
          <div
            ref={overLayRef}
            className="modal_overlay absolute top-0 right-0 flex justify-end w-full h-full cursor-pointer bg-[#13111173]"
            onClick={handleOverLayClick}
          >
            <div className="modal_box relative bg-[#fff] h-full w-[380px] right-0 rounded-l-lg">
              <div
                onClick={onClose}
                className="close absolute top-1 right-1 flex items-center justify-center rounded-full
                hover:bg-slate-200 p-3 hover:rounded-full hover:text-center "
              >
                <span className="hover:rotate-90 hover:transform  transition duration-150 ease-in-out">
                  <IoMdClose size={29} className="" />
                </span>
              </div>
              <div className="title pt-20 px-5">
                <h1 className="text-2xl font-semibold text-[#071827]">
                  {" "}
                  {title}
                </h1>
                <p className="text-base font-medium text-[#5C6F7F]">
                  {subtitle}
                </p>
              </div>
              <div className="modal_content mx-5 relative h-full">
                <form action="" className="">
                  <div className="relative mt-3 space-y-4">
                    <input
                      type="text"
                      name="role"
                      id="role"
                      placeholder="Enter Role"
                      className="p-4 rounded-md bg-[#F2FAF7] border w-full outline-[#0eb683] "
                      required
                      onChange={(evt) => {
                        const inputValue = evt.target.value;
                        setRole(inputValue);
                      }}
                    />

                    <textarea
                      name="roleDescription"
                      id="roleDescription"
                      //   cols={10}
                      //   rows={10}
                      placeholder="Enter role description"
                      onChange={(evt) => {
                        const inputValue = evt.target.value;
                        setRoleDescription(inputValue);
                      }}
                      className="p-4 rounded-md bg-[#F2FAF7] border w-full outline-[#0eb683]"
                    ></textarea>
                  </div>
                  <div className="w-full  absolute bottom-52">
                    <div className="w-full  ">
                      <button
                        onClick={handleRoleCreation}
                        className="text-[#fff] bg-[#0eb683]  w-full py-3 rounded-md  active:scale-90 transition-all"
                      >
                        {loading ? "Loading..." : "Create"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default AddRole;
